import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import { computed, defineComponent, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import localCache from '@/utils/localCache';
import useArchivesInfo from './hooks/useArchivesInfo';
import useExecRelease from './hooks/useExecRelease';
import { Toast } from 'vant';
export default defineComponent({
  name: 'MaterialPositionInfo',
  components: {},
  setup: function setup() {
    var route = useRoute();
    var router = useRouter();
    if (route.params.id) {
      localCache.setItem('release_info', JSON.stringify({
        id: route.params.id,
        release_nums: route.params.release_nums,
        release_unit: route.params.release_unit,
        stone_id: route.params.stone_id,
        stone_specifications: route.params.stone_specifications,
        inventory_no: route.params.inventory_no
      }));
    }
    var release_info = ref(JSON.parse(localCache.getItem('release_info')));
    var params = computed(function () {
      return {
        inventory_no: release_info.value.inventory_no,
        stone_id: release_info.value.stone_id,
        stone_specifications: release_info.value.stone_specifications
      };
    });
    //获取领用详情
    var _useArchivesInfo = useArchivesInfo(params),
      _useArchivesInfo2 = _slicedToArray(_useArchivesInfo, 2),
      info = _useArchivesInfo2[0],
      getArchivesInfoAsync = _useArchivesInfo2[1];
    var params1 = computed(function () {
      return {
        id: release_info.value.id,
        inventory_no: release_info.value.inventory_no,
        execute_nums: release_info.value.release_nums
      };
    });
    //确认领用
    var _useExecRelease = useExecRelease(params1),
      _useExecRelease2 = _slicedToArray(_useExecRelease, 1),
      execReleaseAsync = _useExecRelease2[0];
    onMounted(function () {
      getArchivesInfoAsync();
    });
    var toPickingExWarehouse = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return execReleaseAsync();
            case 3:
              res = _context.sent;
              Toast(res.info);
              setTimeout(function () {
                router.back();
              }, 500);
              _context.next = 10;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 8]]);
      }));
      return function toPickingExWarehouse() {
        return _ref.apply(this, arguments);
      };
    }();
    return {
      release_info: release_info,
      info: info,
      toPickingExWarehouse: toPickingExWarehouse
    };
  }
});